export const MODALS = {
  zoom: 'modal-zoom',
  schedulerManage: 'modal-scheduler-manage',
  consultation: 'modal-consultation',
  nutritionConsultation: 'modal-nutrition-consultation',
  psychologist: 'modal-psychologist',
  nutritionist: 'modal-nutritionist',
  confirm: 'modal-confirm',
  taskManage: 'modal-task-manage',
  nutritionTaskManage: 'modal-nutrition-task-manage',
  callbackInfo: 'modal-callback-info',
  feedbackManage: 'modal-feedback-manage',
  nutritionFeedbackManage: 'modal-nutrition-feedback-manage',
  noteManage: 'modal-note-manage',
  nutritionNoteManage: 'modal-nutrition-note-manage',
  problemManage: 'modal-problem-manage',
  filterManage: 'modal-filter-manage',
  nutritionFilterManage: 'modal-nutrition-filter-manage',
  centersManage: 'modal-centers-manage',
  centerServices: 'modal-center-services',
  centerServiceManage: 'modal-center-service-manage',
  centerServicePriceManage: 'modal-center-service-price-manage',
  giftConsultation: 'modal-gift-consultation',
  promoManage: 'modal-promo-manage',
  changeUserPassword: 'modal-change-user-password',
  featureManage: 'modal-feature-manage',
  nutritionFeatureManage: 'modal-nutrition-feature-manage',
  lightbox: 'modal-lightbox',
  bannerManage: 'modal-banner-manage',
};
